import ApolloClientProvider from 'graphql/client'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { ErrorBoundary } from 'react-error-boundary'
import AppErrorBoundaryFallback from 'error-handling/fallbacks/App'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'
import store from './redux/store'
import reportWebVitals from './reportWebVitals'
import { initializePerformance } from 'utils/performance'

try {
  initializePerformance()
} catch {
  // Monitoring must not prevent the application from starting.
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <ErrorBoundary FallbackComponent={AppErrorBoundaryFallback}>
    <Provider store={store}>
      <BrowserRouter>
        <ApolloClientProvider>
          <App />
        </ApolloClientProvider>
      </BrowserRouter>
    </Provider>
  </ErrorBoundary>,
)
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.register()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
